import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { PDFDocument } from "pdf-lib"; // Importation de pdf-lib
import {
  Button,
  Input,
  Textarea,
  Typography,
  Alert,
  Select,
  Option,
} from "@material-tailwind/react";

export const FormContact = () => {
  const form = useRef();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [color, setColor] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState("Inscription");
  const [selectedClass, setSelectedClass] = useState("");
  const [message, setMessage] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  // const [pdfPreview, setPdfPreview] = useState("");

  // console.log("select : ", selectedRequest);

  const handleCheckboxChange = (value) => {
    setSelectedRequest(selectedRequest === value ? "" : value);
  };

  const validateMessage = (text) => {
    return text.replace(/\s+/g, " ").trim().length >= 200;
  };

  const handleMessageChange = (e) => {
    const text = e.target.value;
    setMessage(text);
    if (!validateMessage(text)) {
      setErrorMessage("Votre message doit contenir au moins 200 caractères.");
      setColor("red");
    } else {
      setErrorMessage("");
    }
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    // Validation
    if (!selectedRequest) {
      setErrorMessage("Veuillez sélectionner une demande.");
      setColor("red");
      return;
    }

    if (!validateMessage(message)) {
      setErrorMessage("Votre message doit contenir au moins 200 caractères.");
      setColor("red");
      return;
    }

    setLoading(true);

    try {
      // Préparer les paramètres pour EmailJS
      let templateParams = {};

      if (selectedRequest === "Inscription") {
        templateParams = {
          request_type: selectedRequest,
          last_name: e.target["last-name"].value,
          first_name: e.target["first-name"].value,
          last_name_2: e.target["last-name-2"].value || "",
          first_name_2: e.target["first-name-2"].value || "",
          last_name_children: e.target["last-name-children"].value,
          first_name_children: e.target["first-name-children"].value,
          naissance: e.target.naissance.value,
          classe: selectedClass,
          email: e.target.email.value,
          phone: e.target.phone.value,
          message: message,
          // has_pdf: !!pdfFile,
          // pdf_name: pdfFile ? pdfFile.name : "",
          // pdf_content: pdfBase64, // Envoie le contenu en base64
          // pdf_size: pdfFile ? (pdfFile.size / 1024).toFixed(2) + "KB" : "",
        };
      } else {
        templateParams = {
          request_type: selectedRequest,
          last_name: e.target["last-name"].value,
          first_name: e.target["first-name"].value,
          objet: e.target["objet"].value,
          email: e.target.email.value,
          phone: e.target.phone.value,
          message: message,
        };
      }

      const template_theme =
        selectedRequest === "Inscription"
          ? "template_79rta5a"
          : "template_h3vo3qf";

      // Envoi via EmailJS
      await emailjs.send(
        "service_kii1kqo",
        template_theme,
        templateParams,
        "3wrWyCDmSy0nsxKTA"
      );

      // Succès
      setSuccessMessage("Votre message a été envoyé avec succès !");
      setColor("success");
      form.current.reset();
      setMessage("");
      // setPdfFile(null);
      // setPdfPreview("");
    } catch (error) {
      console.error("Erreur lors de l'envoi:", error);
      setErrorMessage("Une erreur est survenue. Veuillez réessayer.");
      setColor("error");
    } finally {
      setLoading(false);
      setTimeout(() => {
        setSuccessMessage("");
        setErrorMessage("");
      }, 5000);
    }
  };

  return (
    <>
      {loading && (
        <div className="bg-black opacity-50 w-screen h-screen z-[99] fixed top-0 left-0 flex items-center justify-center">
          <span className="loading loading-dots loading-lg text-white"></span>
        </div>
      )}

      <form
        ref={form}
        onSubmit={sendEmail}
        className="flex flex-col gap-4 lg:max-w-sm"
        id="formulaire"
      >
        <fieldset id="contenu">
          <Typography
            variant="small"
            className="text-left !font-semibold !text-gray-600"
          >
            <legend>Sélectionnez votre demande</legend>
          </Typography>
          <div className="flex gap-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                name="request_type"
                value="Inscription"
                checked={selectedRequest === "Inscription"}
                onChange={() => handleCheckboxChange("Inscription")}
                className="accent-brown-500"
              />
              Inscription
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                name="request_type"
                value="Information"
                checked={selectedRequest === "Information"}
                onChange={() => handleCheckboxChange("Information")}
                className="accent-brown-500"
              />
              Information
            </label>
          </div>
        </fieldset>

        {errorMessage && errorMessage.includes("demande") && (
          <p className="text-red-900 text-sm mt-1">{errorMessage}</p>
        )}

        {/* Nom du parent */}
        {selectedRequest === "Inscription" || selectedRequest === "" ? (
          // PARTIE INSCRIPTION
          <>
            <div className="grid grid-cols-2 gap-4 mt-2">
              <div>
                <Input
                  id="lastname"
                  color="black"
                  size="lg"
                  placeholder="Nom du parent"
                  label="Nom du parent"
                  aria-label="Nom du parent"
                  name="last-name"
                  required
                  containerProps={{ className: "!min-w-full" }}
                  labelProps={{
                    className: "[&>span]:!text-red-900",
                    htmlFor: "lastname",
                  }}
                />
              </div>
              <div>
                <Input
                  id="firstname"
                  color="black"
                  size="lg"
                  placeholder="Prénom du parent"
                  name="first-name"
                  label="Prénom du parent"
                  aria-label="Prénom du parent"
                  required
                  containerProps={{ className: "!min-w-full" }}
                  labelProps={{
                    className: "[&>span]:!text-red-900",
                    htmlFor: "firstname",
                  }}
                />
              </div>
            </div>
            {/* Deuxieme parent optionelle*/}
            <div className="grid grid-cols-2 gap-4 mt-2">
              <div>
                <Input
                  id="lastname2"
                  color="black"
                  size="lg"
                  placeholder="Nom du parent 2"
                  label="Nom du parent 2"
                  aria-label="Nom du parent 2"
                  name="last-name-2"
                  containerProps={{
                    className: "!min-w-full",
                  }}
                  labelProps={{
                    htmlFor: "lastname2",
                  }}
                />
              </div>
              <div>
                <Input
                  id="firstname2"
                  color="black"
                  size="lg"
                  placeholder="Prénom du parent 2"
                  name="first-name-2"
                  label="Prénom du parent 2"
                  aria-label="Prénom du parent 2"
                  containerProps={{
                    className: "!min-w-full",
                  }}
                  labelProps={{
                    htmlFor: "firstname2",
                  }}
                />
              </div>
            </div>
            {/* Nom / Prenom de l'enfant */}
            <div className="grid grid-cols-2 gap-4 mt-2">
              <div>
                <Input
                  id="lastnamechildren"
                  color="black"
                  size="lg"
                  placeholder="Nom de l'enfant"
                  label="Nom de l'enfant"
                  aria-label="Nom de l'enfant"
                  name="last-name-children"
                  required
                  containerProps={{ className: "!min-w-full" }}
                  labelProps={{
                    className: "[&>span]:!text-red-900",
                    htmlFor: "lastnamechildren",
                  }}
                />
              </div>
              <div>
                <Input
                  id="firstnamechildren"
                  color="black"
                  size="lg"
                  placeholder="Prénom de l'enfant"
                  name="first-name-children"
                  label="Prénom de l'enfant"
                  aria-label="Prénom de l'enfant"
                  required
                  containerProps={{ className: "!min-w-full" }}
                  labelProps={{
                    className: "[&>span]:!text-red-900",
                    htmlFor: "firstnamechildren",
                  }}
                />
              </div>
            </div>
            {/* Date de naissance de l'enfant + Classe souhaitée*/}
            <div className="grid grid-cols-2 gap-4 mt-2">
              {/* Date de naissance de l'enfant */}
              <div>
                <Input
                  id="date"
                  type="date"
                  color="black"
                  size="lg"
                  placeholder="Naissance de l'enfant"
                  label="Naissance de l'enfant"
                  name="naissance"
                  required
                  containerProps={{ className: "!min-w-full mt-2" }}
                  labelProps={{
                    className: "[&>span]:!text-red-900",
                    htmlFor: "date",
                  }}
                  aria-label="Date de naissance de l'enfant"
                />
              </div>

              {/* Classe souhaitée de l'enfant */}
              <div>
                <Select
                  id="classe"
                  value={selectedClass}
                  label="Classe souhaitée"
                  name="classe"
                  onChange={(value) => setSelectedClass(value)}
                  required
                  className="focus:outline-1 outline-black"
                  containerProps={{ className: "min-w-full mt-2" }}
                  labelProps={{
                    className: "[&>span]:!text-red-900 text-gray-600",
                    htmlFor: "classe",
                  }}
                  aria-label="Classe de l'enfant souhaitée"
                >
                  {/* Maternelle */}
                  <Option disabled className="text-olive font-extrabold">
                    Maternelle
                  </Option>
                  <Option value="petite-section">Petite Section</Option>
                  <Option value="moyenne-section">Moyenne Section</Option>
                  <Option value="grande-section">Grande Section</Option>

                  {/* Primaire */}
                  <Option disabled className="text-olive font-extrabold">
                    Primaire
                  </Option>
                  <Option value="cp">CP</Option>
                  <Option value="ce1">CE1</Option>
                  <Option value="ce2">CE2</Option>
                  <Option value="cm1">CM1</Option>
                  <Option value="cm2">CM2</Option>
                </Select>
              </div>
            </div>
          </>
        ) : (
          // PARTIE INFORMATION
          <>
            <div className="grid grid-cols-2 gap-4 mt-2">
              <div>
                <Input
                  id="lastname"
                  color="black"
                  size="lg"
                  placeholder="Nom"
                  label="Nom"
                  aria-label="Nom"
                  name="last-name"
                  required
                  containerProps={{ className: "!min-w-full" }}
                  labelProps={{
                    className: "[&>span]:!text-red-900",
                    htmlFor: "lastname",
                  }}
                />
              </div>
              <div>
                <Input
                  id="firstname"
                  color="black"
                  size="lg"
                  placeholder="Prénom"
                  label="Prénom"
                  aria-label="Prénom"
                  name="first-name"
                  required
                  containerProps={{ className: "!min-w-full" }}
                  labelProps={{
                    className: "[&>span]:!text-red-900",
                    htmlFor: "firstname",
                  }}
                />
              </div>
            </div>
            <div>
              <Input
                id="objet"
                color="black"
                size="lg"
                placeholder="Entretien etc.."
                label="Objet"
                aria-label="Sujet/Objet de l'email"
                name="objet"
                required
                labelProps={{
                  className: "[&>span]:!text-red-900",
                  htmlFor: "objet",
                }}
              />
            </div>
          </>
        )}
        {/* Email */}
        <div>
          <Input
            id="email"
            color="black"
            size="lg"
            placeholder="email@email.com"
            label="Email"
            aria-label="Email"
            name="email"
            required
            type="email"
            labelProps={{
              className: "[&>span]:!text-red-900",
              htmlFor: "email",
            }}
          />
        </div>
        {/* Numéro de téléphone */}
        <div>
          <Input
            id="numero"
            color="black"
            size="lg"
            placeholder="Numéro de téléphone"
            label="Numéro de téléphone"
            aria-label="Numéro de téléphone"
            name="phone"
            required
            type="tel"
            autoComplete="tel"
            labelProps={{
              className: "[&>span]:!text-red-900",
              htmlFor: "numero",
            }}
          />
        </div>

        {/* Message  */}
        <div className="flex flex-col items-start">
          <label htmlFor="message" className="block mb-1 text-sm font-medium">
            Message
          </label>
          <textarea
            id="message"
            className="w-full p-2 border rounded-lg bg-gray-200 focus:bg-transparent focus-visible:bg-transparent"
            aria-label="Message a transmettre"
            name="message"
            rows={4}
            value={message}
            onChange={handleMessageChange}
          />

          {errorMessage && errorMessage.includes("message") && (
            <p className="text-red-900 text-sm mt-1">{errorMessage}</p>
          )}
        </div>

        <Button type="submit" className="w-full bg-vertLogo" disabled={loading}>
          {loading ? "Envoi..." : "Envoyer"}
        </Button>
      </form>

      {(successMessage || errorMessage) && (
        <div>
          <Alert
            className={`alert ${
              color === "success" ? "bg-olive" : "bg-red-600"
            } z-50 max-w-80 fixed top-20 right-2`}
          >
            {successMessage || errorMessage}
          </Alert>
        </div>
      )}
    </>
  );
};
